<script type="text/ecmascript-6">
    import TileQuestion from "./mixin/TileQuestion.vue";

    export default {
        mixins: [
            TileQuestion
        ],
        data(){
            return {
                limits: null,
            };
        },
        props:{
            title: {
                default(){
                    return 'Select Top Panel Style';
                }
            },
            frameMaterial: {
                required: true,
            },
            frameColourExternal: {
                required: true,
            },
            frameColourInternal: {
                required: true,
            },
            measurementKey: {
                required: false,
            },
            measurementLabel: {
                required: false,
            },
            measurement: {
                required: false,
            },
            frameStyleId: {
                required: true,
            },
            doorRange: {
                required: true,
            }
        },
        computed: {
            valid_selection(){
                if (!this.options_loaded) {
                    return false;
                }

                return this.filtered_option_list.find(y => {
                            return y.value == this.localTarget;
                        }) !== undefined;
            },
            thumbURL(){
                return '/thumb/sidepanel/';
            },
            url(){
                return '/api/options/' + this.fabricator + '/top-panel?frame_colour_external=' + this.frameColourExternal + '&frame_colour_internal=' + this.frameColourInternal + '&framematerial=' + this.frameMaterial + '&frame_id=' + this.frameStyleId + '&door_range=' + this.doorRange;
            },
            cache_key(){
                return '_' + this.frameMaterial + '_' + this.frameColourExternal + '_' + this.frameColourInternal + '_' + this.frameStyleId + '_' + this.doorRange;
            },
            panel_required(){
                return this.filtered_option_list.length > 1;
            }
        },
        methods: {
            select_first(){
                if (!Array.isArray(this.filtered_option_list)) {
                    this.localTarget = undefined;
                    return;
                }

                if ((this.filtered_option_list.length === 0)) {
                    this.localTarget = undefined;
                    return;
                }

                var new_value = this.filtered_option_list[0];

                this.localTarget = new_value.value;
            },
        },
        watch: {
            'frameMaterial': function (val, oldVal) {
                this.update_options();
            },
            'frameColourInternal': function (val, oldVal) {
                this.update_options();
            },
            'frameColourExternal': function (val, oldVal) {
                this.update_options();
            },
            'frameStyleId': function (val, oldVal) {
                this.update_options();
            },
            'doorRange': function (val, oldVal) {
                this.update_options();
            }
        },
    }
</script>
